// extracted by mini-css-extract-plugin
export default {"layout":"layout___iWade","layoutInner":"layoutInner___IMDti","instructions":"instructions___yHPWH","copyright":"copyright___AQhdr"};